import { camelCase } from "lodash-es"
import { CamelCase } from "type-fest"

export function typedCamelCase<T extends string>(string: T): CamelCase<T> {
  return camelCase(string) as CamelCase<T>
}

type CamelCaseKeys<T> =
  T extends Array<infer U>
    ? Array<CamelCaseKeys<U>>
    : T extends Record<string, unknown>
      ? {
          [K in keyof T as CamelCase<K & string>]: CamelCaseKeys<T[K]>
        }
      : T

/**
 * Recursively converts all object keys from snake_case to camelCase
 */
export function camelCaseKeys<T extends Record<string, unknown>>(obj: T): CamelCaseKeys<T> {
  if (Array.isArray(obj)) {
    return obj.map((item) => camelCaseKeys(item as Record<string, unknown>)) as CamelCaseKeys<T>
  }

  if (obj !== null && typeof obj === "object") {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const camelKey = camelCase(key)
      ;(acc as Record<string, unknown>)[camelKey] =
        value && typeof value === "object" ? camelCaseKeys(value as Record<string, unknown>) : value
      return acc
    }, {} as CamelCaseKeys<T>)
  }

  return obj as CamelCaseKeys<T>
}
